import React from 'react';
import Typography from 'components/commercetools-ui/atoms/typography';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import { Money } from 'types/entity/product';
import { useFormat } from 'helpers/hooks/useFormat';
import useI18n from 'helpers/hooks/useI18n';

interface Props {
  discountedPrice?: Money | string;
  price?: Money | string;
  isStartingPrice?: boolean;
  isSaleStartingPrice?: boolean;
}

const Prices: React.FC<Props> = ({ price, discountedPrice, isStartingPrice = false, isSaleStartingPrice = false }) => {
  const { locale } = useI18n();
  const { formatMessage: formatProductMessage } = useFormat({ name: 'product' });

  if (!price) {
    return null;
  }

  const formattedPrice = typeof price === 'string' ? price : CurrencyHelpers.formatForCurrency(price, locale);

  const formattedDiscountedPrice = discountedPrice
    ? typeof discountedPrice === 'string'
      ? discountedPrice
      : CurrencyHelpers.formatForCurrency(discountedPrice, locale)
    : '';

  const priceLabel = isSaleStartingPrice
    ? formatProductMessage({ id: 'sale.starting.price', defaultMessage: 'Sale starting at' })
    : isStartingPrice
      ? formatProductMessage({ id: 'starting.price', defaultMessage: 'Starting at' })
      : discountedPrice
        ? formatProductMessage({ id: 'sale.price', defaultMessage: 'Sale price' })
        : formatProductMessage({ id: 'list.price', defaultMessage: 'List price' });

  return (
    <div className="flex flex-wrap items-baseline">
      <div className="mr-8 whitespace-nowrap">
        <Typography className="body-text text-lg text-text-tertiary">{priceLabel}</Typography>
      </div>
      <div className="flex flex-nowrap items-center gap-8">
        <Typography className="body-text-large whitespace-nowrap font-bold text-text-secondary">
          {discountedPrice ? formattedDiscountedPrice : formattedPrice}
        </Typography>
        {discountedPrice && (
          <Typography className="body-text whitespace-nowrap text-lg font-medium text-text-tertiary line-through">
            {formattedPrice}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default Prices;
